const y = typeof window < "u" && typeof window.document < "u", c = (a) => {
  if (typeof a != "object" || a === null)
    return a;
  if (Array.isArray(a))
    return a.map((t) => c(t));
  const e = {};
  for (const t in a)
    if (Object.prototype.hasOwnProperty.call(a, t)) {
      const n = t.replace(/([A-Z])/g, "_$1").toLowerCase();
      e[n] = c(a[t]);
    }
  return e;
};
class h {
  async collect() {
    var t, n;
    if (!navigator.storage)
      return;
    const e = await ((n = (t = navigator.storage).estimate) == null ? void 0 : n.call(t));
    return {
      estimate: {
        quota: e == null ? void 0 : e.quota,
        usage: e == null ? void 0 : e.usage
      },
      can_persist: await navigator.storage.persist(),
      persisted: await navigator.storage.persisted()
    };
  }
}
class f {
  async collect() {
    if (navigator.userActivation)
      return {
        has_been_active: navigator.userActivation.hasBeenActive,
        is_active: navigator.userActivation.isActive
      };
  }
}
class b {
  async collect() {
    if (navigator.virtualKeyboard)
      return {
        bounding_rect: navigator.virtualKeyboard.boundingRect
      };
  }
}
class m {
  async collect() {
    if (navigator.connection)
      return {
        downlink: navigator.connection.downlink,
        downlink_max: navigator.connection.downlinkMax,
        effective_type: navigator.connection.effectiveType,
        rtt: navigator.connection.rtt,
        save_data: navigator.connection.saveData,
        type: navigator.connection.type
      };
  }
}
class A {
  getVersion() {
    var t, n, r, o, i;
    if (!navigator.userAgent)
      return;
    let e;
    try {
      navigator.userAgent.includes("Chrome") ? e = (t = navigator.userAgent.match(/Chrome\/(\S+)/)) == null ? void 0 : t[1] : navigator.userAgent.includes("Firefox") ? e = (n = navigator.userAgent.match(/Firefox\/(\S+)/)) == null ? void 0 : n[1] : navigator.userAgent.includes("Safari") ? e = (r = navigator.userAgent.match(/Version\/(\S+)/)) == null ? void 0 : r[1] : navigator.userAgent.includes("MSIE") || navigator.userAgent.includes("Trident/") ? e = (o = navigator.userAgent.match(/(?:MSIE |rv:)(\S+)/)) == null ? void 0 : o[1] : navigator.userAgent.includes("Edge") ? e = (i = navigator.userAgent.match(/Edge\/(\S+)/)) == null ? void 0 : i[1] : e = void 0;
    } catch {
      e = void 0;
    }
    return e;
  }
  getIsUserAgentSuspicious() {
    if (!navigator.userAgent)
      return;
    const e = [
      /bot/i,
      /crawler/i,
      /spider/i,
      /malicious-pattern/i
      // Add more suspicious patterns as needed
    ];
    for (const t of e)
      if (t.test(navigator.userAgent))
        return !0;
    return !1;
  }
  async collect() {
    var n, r, o, i, s;
    const e = (n = navigator.userAgent) == null ? void 0 : n.includes("Mobi"), t = (r = navigator.userAgent) == null ? void 0 : r.includes("Tablet");
    return {
      user_agent: navigator.userAgent,
      language: navigator.language,
      languages: navigator.languages,
      is_mobile: e,
      is_tablet: t,
      is_desktop: !e && !t,
      is_cookie_enabled: navigator.cookieEnabled,
      is_online: navigator.onLine,
      is_webdriver: navigator.webdriver,
      version: this.getVersion(),
      is_user_agent_suspicious: this.getIsUserAgentSuspicious(),
      is_webrtc_activated: typeof RTCPeerConnection < "u",
      user_timezone: (s = (o = Intl == null ? void 0 : Intl.DateTimeFormat) == null ? void 0 : (i = o.call(Intl)).resolvedOptions) == null ? void 0 : s.call(i).timeZone,
      pdf_viewer_enabled: navigator.pdfViewerEnabled
    };
  }
}
class C {
  async collect() {
    return {
      device_memory: navigator.deviceMemory,
      max_touch_points: navigator.maxTouchPoints,
      hardware_concurrency: navigator.hardwareConcurrency
    };
  }
}
class E {
  async collect() {
    const t = document.createElement("canvas").getContext("webgl");
    if (!t)
      return {
        is_webgl_enabled: !1
      };
    const n = t.getExtension("WEBGL_debug_renderer_info");
    return n ? {
      webgl_vendor: t.getParameter(t.VENDOR),
      webgl_renderer: t.getParameter(t.RENDERER),
      webgl_version: t.getParameter(t.VERSION),
      webgl_shading_language_version: t.getParameter(t.SHADING_LANGUAGE_VERSION),
      webgl_unmasked_vendor: t.getParameter(n.UNMASKED_VENDOR_WEBGL),
      webgl_unmasked_renderer: t.getParameter(n.UNMASKED_RENDERER_WEBGL),
      is_webgl_enabled: !0,
      is_debug_renderer_info_available: !0
    } : {
      is_debug_renderer_info_available: !1
    };
  }
}
class D {
  async collect() {
    if (!navigator.getBattery)
      return;
    const e = await navigator.getBattery();
    return {
      is_charging: e.charging,
      level: e.level,
      charging_time: e.chargingTime === 1 / 0 ? "Infinity" : e.chargingTime,
      discharging_time: e.dischargingTime === 1 / 0 ? "Infinity" : e.dischargingTime
    };
  }
}
class I {
  async collect() {
    var e, t, n, r;
    return {
      is_touch_screen: Number(window.navigator.msMaxTouchPoints) > 0 || Number(window.navigator.maxTouchPoints) > 0 || "ontouchstart" in window.navigator,
      width: screen == null ? void 0 : screen.width,
      height: screen == null ? void 0 : screen.height,
      avail_width: screen == null ? void 0 : screen.availWidth,
      avail_height: screen == null ? void 0 : screen.availHeight,
      inner_width: window.innerWidth,
      inner_height: window.innerHeight,
      orientation: (t = (e = window.screen) == null ? void 0 : e.orientation) == null ? void 0 : t.type,
      is_full_screen_supported: document.fullscreenEnabled || document.webkitFullscreenEnabled,
      is_full_screen: document.fullscreenElement !== null,
      color_depth: (n = window.screen) == null ? void 0 : n.colorDepth,
      pixel_depth: (r = window.screen) == null ? void 0 : r.pixelDepth
    };
  }
}
class P {
  async collect() {
    var t, n;
    const e = await ((n = (t = navigator.mediaDevices) == null ? void 0 : t.enumerateDevices) == null ? void 0 : n.call(t));
    if (e)
      return e.map((r) => ({
        device_id: r.deviceId,
        group_id: r.groupId,
        kind: r.kind,
        label: r.label
      }));
  }
}
class k {
  async collect() {
    if (!navigator.getGamepads)
      return;
    let e;
    try {
      e = Array.from(navigator.getGamepads());
    } catch {
      return;
    }
    return e.map((t) => t && {
      axes: t.axes,
      buttons: t.buttons,
      connected: t.connected,
      hand: t.hand,
      haptic_actuators: c(t.hapticActuators),
      vibration_actuator: c(t.vibrationActuator),
      id: t.id,
      index: t.index,
      mapping: c(t.mapping),
      pose: c(t.pose),
      timestamp: t.timestamp
    });
  }
}
class x {
  async collect() {
    if (!navigator.getInstalledRelatedApps)
      return;
    let e;
    try {
      e = await navigator.getInstalledRelatedApps();
    } catch {
      return;
    }
    return e.map((t) => t);
  }
}
class N {
  async collect() {
    if (navigator.userAgentData)
      return {
        brands: c(navigator.userAgentData.brands),
        mobile: navigator.userAgentData.mobile,
        platform: navigator.userAgentData.platform
      };
  }
}
class R {
  async collect() {
    var e, t;
    if (navigator.windowControlsOverlay)
      return {
        visible: navigator.windowControlsOverlay.visible,
        titlebar_area_rect: await ((t = (e = navigator.windowControlsOverlay).getTitlebarAreaRect) == null ? void 0 : t.call(e))
      };
  }
}
class S {
  async getCurrentPosition() {
    return new Promise((e, t) => {
      navigator.geolocation.getCurrentPosition((n) => {
        e(n);
      }, t);
    });
  }
  async collect() {
    try {
      const e = await this.getCurrentPosition();
      return {
        timestamp: e.timestamp,
        coords: {
          latitude: e.coords.latitude,
          longitude: e.coords.longitude,
          altitude: e.coords.altitude,
          accuracy: e.coords.accuracy,
          altitude_accuracy: e.coords.altitudeAccuracy,
          heading: Number.isNaN(e.coords.heading) ? "NaN" : e.coords.heading,
          speed: e.coords.speed
        }
      };
    } catch {
      return;
    }
  }
}
class T {
  async collect() {
    if (!y)
      throw new Error("This script can only run in Browser environment");
    const e = new S(), t = new h(), n = new f(), r = new b(), o = new m(), i = new A(), s = new C(), l = new E(), g = new D(), d = new I(), u = new P(), v = new k(), w = new x(), _ = new N(), p = new R();
    return {
      geolocation: await e.collect(),
      storage: await t.collect(),
      user_activation: await n.collect(),
      virtual_keyboard: await r.collect(),
      connection: await o.collect(),
      browser: await i.collect(),
      hardware: await s.collect(),
      webgl: await l.collect(),
      battery: await g.collect(),
      display: await d.collect(),
      media_devices: await u.collect(),
      gamepads: await v.collect(),
      installed_related_apps: await w.collect(),
      user_agent_data: await _.collect(),
      window_controls_overlay: await p.collect()
    };
  }
}
export {
  T as default
};
